import { Routes } from '@angular/router';
import { AppLayout } from '@/layout/components/app.layout';
import { authenticationChildGuard } from '@/features/auth/guards/authentication.guard';

export const appRoutes: Routes = [
    {
        path: 'auth/login',
        loadComponent: () =>
            import('./app/features/auth/ui/login-page.component').then(
                (c) => c.LoginPageComponent
            )
    },
    {
        path: '',
        component: AppLayout,
        canActivateChild: [authenticationChildGuard],
        children: [
            {
                path: '',
                pathMatch: 'full',
                redirectTo: 'dashboard'
            },
            {
                path: 'dashboard',
                loadComponent: () =>
                    import('./app/pages/dashboard/dashboard.component').then(
                        (c) => c.DashboardComponent
                    ),
                data: { breadcrumb: { skip: true } }
            },
            {
                path: 'course',
                loadChildren: () =>
                    import('./app/features/course/course.routes').then(
                        (m) => m.COURSE_ROUTES
                    ),
                data: { breadcrumb: 'Course' }
            },
            {
                path: 'user',
                loadChildren: () =>
                    import('./app/features/user/user.routes').then(
                        (m) => m.USER_ROUTES
                    ),
                data: { breadcrumb: 'User' }
            },
            {
                path: 'inbox',
                loadChildren: () =>
                    import('./app/features/inbox/inbox.routes').then(
                        (m) => m.INBOX_ROUTES
                    ),
                data: { breadcrumb: 'Inbox' }
            },
            {
                path: 'slot',
                loadChildren: () =>
                    import('./app/features/slot/slot.routes').then(
                        (m) => m.SLOT_ROUTES
                    ),
                data: { breadcrumb: 'Slot' }
            },
            {
                path: 'reserve',
                loadChildren: () =>
                    import('./app/features/reserve/reserve.routes').then(
                        (m) => m.RESERVE_ROUTES
                    ),
                data: { breadcrumb: 'Reserve' }
            },
            {
                path: 'transfers',
                loadChildren: () =>
                    import('./app/features/settlement/settlement.routes').then(
                        (m) => m.SETTLEMENT_ROUTES
                    ),
                data: { breadcrumb: 'Settlement' }
            },
            {
                path: 'reserves',
                children: [
                    {
                        path: 'course-credit-management',
                        loadComponent: () =>
                            import('./app/features/settlement/pages/settlement-credits.component').then(
                                (c) => c.SettlementCreditsComponent
                            ),
                        data: { breadcrumb: 'Credits' }
                    }
                ],
                data: { breadcrumb: 'Settlement' }
            },
            {
                path: 'coupon',
                loadComponent: () =>
                    import('./app/features/settlement/pages/settlement-coupons.component').then(
                        (c) => c.SettlementCouponsComponent
                    ),
                data: { breadcrumb: 'Coupons' }
            },
            {
                path: 'price-rule',
                loadChildren: () =>
                    import('./app/features/price-rule/price-rule.routes').then(
                        (m) => m.PRICE_RULE_ROUTES
                    ),
                data: { breadcrumb: 'Price Rule' }
            },
            {
                path: 'audit',
                loadChildren: () =>
                    import('./app/features/audit/audit.routes').then(
                        (m) => m.AUDIT_ROUTES
                    ),
                data: { breadcrumb: 'Audit' }
            },
            {
                path: 'rewards',
                loadChildren: () =>
                    import('./app/features/reward/reward.routes').then(
                        (m) => m.REWARD_ROUTES
                    ),
                data: { breadcrumb: 'Reward' }
            },
            {
                path: 'voucher',
                loadChildren: () =>
                    import('./app/features/voucher/voucher.routes').then(
                        (m) => m.VOUCHER_ROUTES
                    ),
                data: { breadcrumb: 'Voucher' }
            },
            {
                path: 'portal',
                loadChildren: () =>
                    import('./app/features/partner-login/partner-login.routes').then(
                        (m) => m.PARTNER_LOGIN_ROUTES
                    ),
                data: { breadcrumb: 'Portal' }
            },
            {
                path: 'monitoring-zone',
                loadChildren: () =>
                    import('./app/features/monitoring-zone/monitoring-zone.routes').then(
                        (m) => m.MONITORING_ZONE_ROUTES
                    ),
                data: { breadcrumb: 'Monitoring Zones' }
            },
            {
                path: 'sales-monitor',
                loadChildren: () =>
                    import('./app/features/sales-monitor/sales-monitor.routes').then(
                        (m) => m.SALES_MONITOR_ROUTES
                    ),
                data: { breadcrumb: 'Sales Monitor' }
            },
            {
                path: 'course-sales-target',
                loadChildren: () =>
                    import('./app/features/course-sales-target/course-sales-target.routes').then(
                        (m) => m.COURSE_SALES_TARGET_ROUTES
                    ),
                data: { breadcrumb: 'Course Sales Targets' }
            },
            {
                path: 'agents',
                loadChildren: () =>
                    import('./app/features/agent/agent.routes').then(
                        (m) => m.AGENT_ROUTES
                    ),
                data: { breadcrumb: 'Agents' }
            }
        ]
    },
    {
        path: 'auth',
        pathMatch: 'full',
        redirectTo: 'auth/login'
    },
    { path: '**', redirectTo: 'auth/login' }
];
